import { name } from "./__init__";
import { createSelector } from "reselect";
import { selectors as appSelectors } from "../../containers/App";
import {
  getSpecificQuestionnaireType,
  propertyDataSelector,
  propertyTickerSelector,
} from "../ReservationManager/selectors";
import constants from "../../utils/constants";
import { localeSelector, reservationSelector } from "../App/selectors";

// getModelSelector :: State -> Model
export const getModelSelector = state => state[name];

export const cancelStatusSelector = createSelector(getModelSelector, model => {
  let result = null;

  if (model) {
    result = {
      loaded: model.get("cancelLoaded"),
      loading: model.get("cancelLoading"),
      error: model.get("cancelError"),
    };
  }

  return result;
});

export const configurationSelector = createSelector(
  appSelectors.configurationSelector,
  configuration => {
    return (
      configuration && {
        showAgent: configuration.get("showAgent"),
        displayDailyRates: configuration.get("displayDailyRates"),
      }
    );
  }
);

export const cancellationFormQuestionnaireSelector = createSelector(
  propertyDataSelector,
  propertyTickerSelector,
  localeSelector,
  (propertyData, propertyTicker, locale) => {
    const result = getSpecificQuestionnaireType(
      propertyData,
      propertyTicker,
      constants.QUESTIONNAIRE_DEPENDER_TYPE.CANCELLATION_FORM
    );

    const fallback = [
      {
        id: 0,
        propertyTicker: propertyTicker,
        ticker: "cancellation",
        active: true,
        dependers: [
          {
            type: "CANCELLATION_FORM",
          },
        ],
        fields: [
          {
            widget: "INPUT",
            ticker: "reason",
            label: "reservation_confirmed.cancellation.cancellationReason",
            position: 0,
            active: true,
            items: [],
            constraints: {},
          },
        ],
        locale: locale,
      },
    ];
    return result && result.length > 0 ? result : fallback;
  }
);

export const cancellationRestrictionsConfirmationSelector = createSelector(
  reservationSelector,
  reservation => {
    if (reservation && reservation.get("roomReservations")) {
      return reservation
        .get("roomReservations")
        .map(
          res =>
            res.get("cancellationPolicy") && res.get("cancellationPolicy").get("configurations")
        )
        .toJS();
    }
  }
);

export const cancellationPoliciesInfoConfirmationSelector = createSelector(
  reservationSelector,
  reservation => {
    if (reservation && reservation.get("roomReservations")) {
      return reservation
        .get("roomReservations")
        .map(
          res => res.get("cancellationPolicy") && res.get("cancellationPolicy").get("description")
        )
        .toJS();
    }
  }
);

export const smartPaymentIdSelector = createSelector(getModelSelector, model => {
  return model.get("smartPaymentId");
});
